import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { AccountService } from 'src/app/services/account.service';

import { OtherService } from 'src/app/services/other.service';

import { AdsInfiniteScrollService } from '../business-main-infinite-scroll/service/ads-infinite-scroll.service';

import { ajax } from 'rxjs/ajax';

import { environment } from 'src/environments/environment';

@Component({

  selector: 'app-driver-ads',

  templateUrl: './driver-ads.component.html',

  styleUrls: ['./driver-ads.component.css']

})

export class DriverAdsComponent implements OnInit {

  lst_City: any = [];

  lst_MobileType: any = [];

  lst_GpsType: any = [];

  lst_Ads: any = [];

  lst_Type: any = [];

  showFilter: boolean = true;

  bResults: boolean = true;

  bDataEnded: boolean = false;

  bScrollLoading: boolean = false;

  isResultLoading: boolean = false;

  bUpButton: boolean = false;

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(0),

    strSession: new FormControl(''),

    tiMobileType: new FormControl('-1'),

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

    strCity: new FormControl(''),

    tiType: new FormControl('-1'),

    tiGPSType: new FormControl('-1'),

    bHourly: new FormControl(false),

    bDaily: new FormControl(false),

    bWeekly: new FormControl(false),

    bMonthly: new FormControl(false),

    bKeyInHand: new FormControl(false),

    iPage: new FormControl('-1'),

    iTotal: new FormControl('0'),

  })

  @ViewChild('point_1', { static: false }) private my_point_1: ElementRef;

  @ViewChild('firstResult') firstResult: ElementRef;

  @ViewChild('upButton') upButton: ElementRef;

  constructor(

    private router: Router,

    private route: ActivatedRoute,

    private FormBuilder: FormBuilder,

    private _otherService: OtherService,

    private _service: AccountService,

    private _InfiniteScrollService: AdsInfiniteScrollService,

    // private _UpButtonServiceService: UpButtonServiceService


  ) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe((data: any) => {

      this.mdl_Search.patchValue({

        iSystemUser: this._otherService.getLocalStorage()?.Id ? this._otherService.getLocalStorage().Id : 0,

        strSession: this._otherService.getLocalStorage()?.session ? this._otherService.getLocalStorage().session : '',

        tiType: data.type ? data.type : -1,

        strCity: data.city ? data.city : '',

        tiMobileType: data.car ? data.car : -1,

        tiGPSType: data.name ? data.name : -1,

        bHourly: data.hourly ? data.hourly : false,

        bDaily: data.daily ? data.daily : false,

        bWeekly: data.weekly ? data.weekly : false,

        bMonthly: data.monthly ? data.monthly : false,

        bKeyInHand: data.key ? data.key : false,

        strSDate: data.start_date ? this.convert_ToSlash(data.start_date) : '',

        strEDate: data.end_date ? this.convert_ToSlash(data.end_date) : '',

      })

    })

    this._otherService.setTitle('تاکسی لون | آگهی های خودرو دربستی، ساعتی، در اختیار سواری،ون،مینی بوس و اتوبوس');

    this.getAllCity();

    this.Taxilon_AdsType();

    this.getAllMobileType();

    this.getAllGpsType();

    this.getAll_Ads(0);

    // listen to user scroll activity

    this._InfiniteScrollService.isScrollToBottom$.subscribe((isScrollBottom: boolean) => {

      if (isScrollBottom && !this.bDataEnded && this.lst_Ads.length && !this.isResultLoading) {

        this.loadMoreData();

      }

    });

    this._InfiniteScrollService.isDataEnded$.subscribe((isEnded: boolean) => {

      if (isEnded) {

        this.bScrollLoading = false;

        this.bDataEnded = true;

      }

    });

  }

  ngOnDestroy() {

    this._otherService.setTitle('');

    this._InfiniteScrollService.update_DataStatus(false);

  }

  getAllCity() {

    this._service.TaxiLon_City_Search(this._otherService.stringNumberToNumber(this.mdl_Search.value)).subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      if (res.iResult == 0) return this._service.toastSwal('error', res.strError);

      this.lst_City = res;

    })

  }

  getAllMobileType() {

    this._service.TaxiLon_MobileType_Search(this._otherService.stringNumberToNumber(this.mdl_Search.value)).subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      if (res.iResult == 0) return this._service.toastSwal('error', res.strError)

      this.lst_MobileType = res;


    })

  }

  getAllGpsType() {

    this._service.TaxiLon_GPSType_Search(this._otherService.stringNumberToNumber(this.mdl_Search.value)).subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      if (res.iResult == 0) return this._service.toastSwal('error', res.strError);

      this.lst_GpsType = res;

    })

  }

  getAll_Ads(type: number) {

    // console.log(type)

    this.addQueryParam();

    this.mdl_Search.patchValue({

      iPage: -1

    })

    this._service.Taxilon_Advertisement(this._otherService.stringNumberToNumber(this.mdl_Search.value)).subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      if (res.iResult == 0 || res.iResult == -1) return this._service.toastSwal('error', res.strError);

      this.mdl_Search.controls['iTotal'].setValue(res.length ? res[0].iTotal : '0');

      this._InfiniteScrollService.update_DataStatus(false);

      this.bDataEnded = false;

      this.bResults = res.length > 0 ? true : false;

      this.lst_Ads = res;

      this.gotoTop();

      if (this.lst_Ads.length > 15) {

        setTimeout(() => {

          const threshold = 0.5;

          const observer_1 = new IntersectionObserver((entries) => {

            entries.forEach((entry) => {

              if (entry.isIntersecting) {

                this.bUpButton = !this.bUpButton;

              }

            });

          }, { threshold });

          const observer_2 = new IntersectionObserver((entries) => {

            entries.forEach((entry) => {

              if (entry.isIntersecting) {

                this.bUpButton = false;

              }

            });

          }, { threshold });

          observer_1.observe(this.upButton.nativeElement);

          observer_2.observe(this.firstResult.nativeElement);

        }, 100);

      }

    })

  }

  subString_Title(text: string, limit?: number) {

    if (limit && text?.length > limit) text = text.slice(0, limit) + '...';

    if (!limit && text?.length > 55) text = text.slice(0, 55) + '...';

    return text;

  }

  remove_Filter(type: string) {

    if (type.startsWith('str')) {

      this.mdl_Search.get(type)?.setValue(type.includes('str') ? '' : -1);

      this.getAll_Ads(2);

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

    }

    if (type.startsWith('b')) {

      this.mdl_Search.get(type)?.setValue(false);

      this.getAll_Ads(3);

    }

    else if (!type.startsWith('str') && !type.startsWith('b')) {

      this.mdl_Search.get(type)?.setValue(type.includes('str') ? '' : -1);

      this.getAll_Ads(4);

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

    }

  }

  remove_Filter_2() {

    this.mdl_Search.patchValue({

      bHourly: false,

      bDaily: false,

      bWeekly: false,

      bMonthly: false,

      bKeyInHand: false

    })

    this.getAll_Ads(5);

  }

  showAds(item) {

    window.open(`/taxilon/job/${this.convertSpaceTo_(item.strTitle, '-')}/${item.iTaxilon_Advertisement}`, '_blank')

  }

  convertSpaceTo_(strTitle, symbol?: string): string {

    return strTitle.trim().replace(/[\s\/\-*]+|or/g, symbol ? symbol : "_");

    return strTitle.trim().replace(/ /g, symbol ? symbol : "_")

  }

  convert_ToSlash(strTitle, symbol?: string): string {

    return strTitle.trim().replace(/-/g, symbol ? symbol : "/")

  }

  hasSelected(type: string): boolean {

    return type.startsWith('str') ? this.mdl_Search.get(type)?.value != '' : type.startsWith('b') ? this.mdl_Search.get(type)?.value != false : Number(this.mdl_Search.get(type)?.value) > -1

  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

  addQueryParam() {

    let model = this.mdl_Search.value;

    this.router.navigate([], {

      relativeTo: this.route, queryParams: {

        type: model.tiType == -1 ? null : model.tiType,

        city: model.strCity == '' ? null : model.strCity,

        car: model.tiMobileType == -1 ? null : model.tiMobileType,

        name: model.tiGPSType == -1 ? null : model.tiGPSType,

        hourly: model.bHourly == false ? null : model.bHourly,

        daily: model.bDaily == false ? null : model.bDaily,

        weekly: model.bWeekly == false ? null : model.bWeekly,

        monthly: model.bMonthly == false ? null : model.bMonthly,

        key: model.bKeyInHand == false ? null : model.bKeyInHand,

        start_date: model.strSDate == '' ? null : this.convertSpaceTo_(model.strSDate, '-'),

        end_date: model.strEDate == '' ? null : this.convertSpaceTo_(model.strEDate, '-'),

      },

      queryParamsHandling: 'merge', // پارامترهای قبلی حفظ شوند

    });

  }

  gotoTop() {

    this.my_point_1.nativeElement.scrollIntoView({

      behavior: 'smooth',

    });

    setTimeout(() => {

      this.bUpButton = false;

    }, 1000);

  }

  Taxilon_AdsType() {

    this._service.Taxilon_AdsType(this._otherService.stringNumberToNumber(this.mdl_Search.value)).subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      if (res.iResult == 0) return this._service.toastSwal('error', res.strError)

      res.unshift({ tiType: -1, strComment: 'همه' });

      this.lst_Type = res;

    })

  }

  loadMoreData() {

    if (this.lst_Ads.length == this.mdl_Search.get('iTotal')?.value) {

      this._InfiniteScrollService.update_DataStatus(true);
    }

    else {

      this.bScrollLoading = true;

      setTimeout(() => {

        this.mdl_Search.get('iPage')?.setValue(this.lst_Ads[this.lst_Ads.length - 1].iPage);

        this.sendDataToApi();

      }, 600);

    }

  }

  sendDataToApi() {

    this.isResultLoading = true;

    ajax.post(environment.taxiUrl + `Taxilon_Advertisement_Public_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value), {

      'Content-Type': 'application/json',

    }).subscribe({

      next: (value: any) => {

        this.isResultLoading = false;

        this.bScrollLoading = false;

        let res = JSON.parse(value.response);

        if (res.bError) {

          this.isResultLoading = false;

          this._InfiniteScrollService.update_DataStatus(true);

          return this._service.toastSwal('error', res.strError);

        }

        if (!res.length) {

          this.isResultLoading = false;

          this._InfiniteScrollService.update_DataStatus(true);

          return this._service.toastSwal('error', 'موردی یافت نشد');

        }

        this.lst_Ads = this.lst_Ads.concat(res);

        this.mdl_Search.get('iTotal')?.setValue(this.lst_Ads[0].iTotal);

        // if "iPage" is Equal to 0 , Stop gathering data

        if (res[res.length - 1].iPage == 0) {

          this._InfiniteScrollService.update_DataStatus(true);

        }

      },

      error: (err) => {

        this._service.toastSwal('error', 'لطفا وضعیت اتصال اینترنت خود را بررسی کنید');

        this.isResultLoading = false;

        this._InfiniteScrollService.update_DataStatus(true);

      },

    });

  }

}
